import React from "react";
import { Descriptions, Drawer, Empty, Spin, Tag, Timeline, Typography } from "antd";
import { HistoryOutlined } from "@ant-design/icons";

import {
    FUEL_PRICE_STATUS_COLORS,
    FUEL_PRICE_STATUS_LABELS,
    OPERATION_TYPE_LABELS,
    PRICE_SOURCE_LABELS,
} from "../constants";
import {
    EMPTY_VALUE,
    formatCurrencyUnit,
    formatDateTime,
    formatPriceDisplay,
    formatSignedNumber,
    formatSignedPercent,
} from "../utils/formatters";

const { Text, Title } = Typography;

const PricePeriodDetailDrawer = ({ open, period, loading, logs, logsLoading, onClose }) => {
    return (
        <Drawer
            title={`价格周期详情 #${period?.id || ""}`}
            open={open}
            onClose={onClose}
            width={600}
            destroyOnClose
        >
            <Spin spinning={loading || logsLoading}>
                {!period ? (
                    <Empty description="暂无价格周期详情" />
                ) : (
                    <>
                        <Descriptions column={2} size="small" bordered style={{ marginBottom: 24 }}>
                            <Descriptions.Item label="机场">{period.airport_code}</Descriptions.Item>
                            <Descriptions.Item label="供应商">{period.vendor?.name || EMPTY_VALUE}</Descriptions.Item>
                            <Descriptions.Item label="周期">{period.period_start} ~ {period.period_end}</Descriptions.Item>
                            <Descriptions.Item label="状态">
                                <Tag color={FUEL_PRICE_STATUS_COLORS[period.status]}>
                                    {FUEL_PRICE_STATUS_LABELS[period.status] || period.status}
                                </Tag>
                            </Descriptions.Item>
                            <Descriptions.Item label="我方预算价">
                                {formatPriceDisplay(period.our_calculated_price, {
                                    currency: period.price_currency,
                                    unit: period.price_unit,
                                    withUnit: true,
                                })}
                            </Descriptions.Item>
                            <Descriptions.Item label="供应商确认价">
                                {formatPriceDisplay(period.supplier_quoted_price, {
                                    currency: period.price_currency,
                                    unit: period.price_unit,
                                    withUnit: true,
                                })}
                            </Descriptions.Item>
                            <Descriptions.Item label="差异">
                                {period.price_difference != null
                                    ? `${formatSignedNumber(period.price_difference)} (${formatSignedPercent(period.price_difference_percent)})`
                                    : EMPTY_VALUE}
                            </Descriptions.Item>
                            <Descriptions.Item label="最终确认价">
                                <Text strong>
                                    {formatPriceDisplay(period.final_confirmed_price, {
                                        currency: period.price_currency,
                                        unit: period.price_unit,
                                        withUnit: true,
                                    })}
                                </Text>
                            </Descriptions.Item>
                            <Descriptions.Item label="计价单位">
                                {formatCurrencyUnit(period.price_currency, period.price_unit)}
                            </Descriptions.Item>
                            <Descriptions.Item label="价格来源">
                                {PRICE_SOURCE_LABELS[period.price_source] || period.price_source || EMPTY_VALUE}
                            </Descriptions.Item>
                            <Descriptions.Item label="确认人">{period.confirmer?.username || EMPTY_VALUE}</Descriptions.Item>
                            <Descriptions.Item label="确认时间">
                                {formatDateTime(period.confirmed_at, "YYYY-MM-DD HH:mm")}
                            </Descriptions.Item>
                            <Descriptions.Item label="创建人">{period.creator?.username || EMPTY_VALUE}</Descriptions.Item>
                            <Descriptions.Item label="创建时间">
                                {formatDateTime(period.created_at, "YYYY-MM-DD HH:mm")}
                            </Descriptions.Item>
                            <Descriptions.Item label="备注" span={2}>
                                {period.remarks || EMPTY_VALUE}
                            </Descriptions.Item>
                        </Descriptions>

                        <Title level={5}>
                            <HistoryOutlined /> 操作历史
                        </Title>
                        {!logs.length ? (
                            <Empty description="暂无操作日志" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        ) : (
                            <Timeline style={{ marginTop: 12 }}>
                                {logs.map((log) => (
                                    <Timeline.Item key={log.id} color={log.operation_type === "STATUS_CHANGED" ? "green" : "blue"}>
                                        <Text strong>{OPERATION_TYPE_LABELS[log.operation_type] || log.operation_type}</Text>
                                        <br />
                                        <Text type="secondary" style={{ fontSize: 12 }}>
                                            {formatDateTime(log.created_at)} · {log.operator_name || "系统"}
                                        </Text>
                                        {log.description ? (
                                            <div style={{ marginTop: 4 }}>
                                                <Text style={{ fontSize: 13 }}>{log.description}</Text>
                                            </div>
                                        ) : null}
                                    </Timeline.Item>
                                ))}
                            </Timeline>
                        )}
                    </>
                )}
            </Spin>
        </Drawer>
    );
};

export default PricePeriodDetailDrawer;
